import { Perfil } from './../../model/perfil';
import { Component, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
//import { UploadInput, UploaderOptions, UploadFile, UploadOutput, UploadStatus, humanizeBytes } from 'ngx-uploader';
import { PerfilService } from '../../service/perfil/perfil.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { PasswordValidator } from '../../validators/PasswordValidator';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ModalAlertService } from '../../modules/modals/alert-window';
import { ModalConfirmService } from '../../modules/modals/confirm-window';


@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.css']
})
export class AlterarSenhaComponent implements AfterViewInit {
  perfil: Perfil = new Perfil();
  buttonText = "Atualizar";
  formData: FormData;
  perfilFormGroup: FormGroup;
  alterandoSenha: boolean;
  
  constructor(private perfilService: PerfilService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private formBuilder: FormBuilder,
    private confirmModalService: ModalConfirmService,
    private alertModalService: ModalAlertService) {
   
    this.perfilFormGroup = this.formBuilder.group({
      password: ['', Validators.required],
      repeatPassword: ['', Validators.required]
    }, {
        validator: PasswordValidator.validate.bind(this)
      });
  }
  ngAfterViewInit() {
    this.LoadPerfil();
  }

  config = {
    displayKey: "nivel",
    search: false
  }

  public LoadPerfil() {
    this.activatedRoute.params.subscribe(param => {
      if (param.id)
        this.perfilService.GetPerfilHash(param.id)
        .catch((err) => {
          this.alertModalService
            .show("Atenção", "Chave de acesso invalida!");
          return null;
        })
        .subscribe((res: Perfil) => {
          if (res) {
            this.perfil = res;
            this.perfil.nm_Senha = null;
          }
        });
    });
  }


  onButtonCreateUpdateClick() {
    this.confirmModalService.show("Redefinir Senha", "Tem certeza que deseja alterar a senha?",
    () => {
      this.perfilService.CreateOrUpdate(this.perfil, 1)
        .catch((err) => {
          this.alertModalService
            .show("Atenção", "Falha ao tentar alterar a senha, contate a equipe responsavel");            
          return null;
        })
        .subscribe((res) => {
          this.alertModalService.show("Redefinir Senha", res["mensagemRetorno"]);
          this.route.navigate(["/alterarSenha"]);
        });
    })

  }
}
